import { canonicalSourceName } from './bottleSources.js'

export const ORIGIN_FIELDS = ['acquired_from_kind', 'acquired_from_name', 'acquired_on', 'is_tester', 'is_blind_buy']
export const ORIGIN_KINDS = [['retailer', 'Retailer'], ['online', 'Online'], ['tiktok_auction', 'TikTok auction'], ['gift', 'Gift'], ['decant_swap', 'Decant / swap'], ['other', 'Other']]
export function originValues(row = {}) {
  return Object.fromEntries(ORIGIN_FIELDS.map(key => [key, row[key] ?? null]))
}
export function normalizeOrigin(row) {
  const values = originValues(row)
  values.acquired_from_kind ||= null
  if (values.acquired_from_kind && !ORIGIN_KINDS.some(([key]) => key === values.acquired_from_kind)) throw new Error('Choose a source from the list.')
  // A store or website name is saved in its listed spelling, so "macys" and "Macy's" are one store.
  values.acquired_from_name = ['retailer', 'online'].includes(values.acquired_from_kind)
    ? canonicalSourceName(values.acquired_from_name)
    : values.acquired_from_name?.trim() || null
  values.acquired_on ||= null
  for (const key of ['is_tester', 'is_blind_buy']) if (values[key] !== null && typeof values[key] !== 'boolean') throw new Error('Invalid bottle toggle.')
  return values
}
export function originSummary(row) {
  return [ORIGIN_KINDS.find(([key]) => key === row.acquired_from_kind)?.[1], row.acquired_from_name, row.acquired_on,
    row.is_tester === true ? 'Tester' : row.is_tester === false ? 'Not a tester' : null,
    row.is_blind_buy === true ? 'Blind buy' : row.is_blind_buy === false ? 'Not a blind buy' : null].filter(Boolean).join(' · ')
}
export async function loadOrigin(client, id) {
  const { data, error } = await client.from('fragrances').select(ORIGIN_FIELDS.join(',')).eq('id', id).single()
  if (error) throw error
  return originValues(data)
}
export async function saveOrigin(client, id, values) {
  const { data, error } = await client.from('fragrances').update(normalizeOrigin(values)).eq('id', id).select(ORIGIN_FIELDS.join(',')).single()
  if (error) throw error
  return originValues(data)
}
